import React, { useState } from 'react';
import Modal from '../../../../../../components/Modal';
import {
  ButtonCancel,
  ButtonContainer,
  ButtonActivate,
  Container,
  Description,
  SuccessText,
  SuccessCircleIcon,
} from './styles';
import { TextField } from 'material-ui';
import DynamicAPI from '../../../../../../shared/axios';
import CircularProgress from '@mui/material/CircularProgress';

const ActivateReceiptStatusModal = ({ data, onBackdropClick, setActivate }) => {
  const [loading, setLoading] = useState(false);
  const [reasonText, setReasonText] = useState('');
  const [successRequest, setSuccessRequest] = useState(false);

  function onChangeReasonTextField(e) {
    setReasonText(e.target.value);
  }

  async function handleActivate() {
    setLoading(true);
    const params = {
      justification: reasonText,
      ...data
    }

    try {
      const http = new DynamicAPI('v1');
      await http.get(
        '/IntegratedTracking/DisableOrEnablePhotoOccurrence',
        params,
      );

      setActivate();
      setSuccessRequest(true);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }

  return (
    <Modal
      title="Reativar imagem"
      size="small"
      hasClose={true}
      onBackdropClick={onBackdropClick}
      secondaryHeader={true}
    >
      {!successRequest ? (
        <Container>
          <Description>
            Atenção! Ao reativar a imagem, o usuário passará a visualizá-la.
            Você poderá inativá-la quando desejar.
          </Description>
          <TextField
            id="standard-basic"
            label="Justificativa"
            variant="standard"
            fullWidth
            placeholder="Digite uma justificativa*"
            maxlength={100}
            required={true}
            onChange={e => onChangeReasonTextField(e)}
          />
          <ButtonContainer>
            <ButtonCancel onClick={onBackdropClick}>Cancelar</ButtonCancel>
            <ButtonActivate
              disabled={reasonText.length === 0 || loading}
              onClick={handleActivate}
            >
              {loading ? <CircularProgress size={27.5} /> : 'Reativar'}
            </ButtonActivate>
          </ButtonContainer>
        </Container>
      ) : (
        <Container>
          <SuccessText>
            <SuccessCircleIcon />
            Imagem reativada com sucesso.
          </SuccessText>
          <Description>
            O usuário passará a visualizá-la. Você poderá inativá-la quando
            desejar.
          </Description>
        </Container>
      )}
    </Modal>
  );
};

export { ActivateReceiptStatusModal };
